import { Box, Heading } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { useCategory } from "../../../hooks/useCategory.ts";
import CategoriesPageCardItem from "../../card/categoriesPageCardItem.tsx";
import { ICategory } from "../../../model.ts";

const Categories: React.FC = () => {
  const [categoryData, setCategoryData] = useState<ICategory[]>([]);
  const { data } = useCategory();

  useEffect(() => {
    if (data?.body) {
      setCategoryData(data.body);
    }
  }, [data]);

  const gapBetweenBoxes = 20;

  const settings = {
    dots: true,
    infinite: true,
    speed: 3000,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 668,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 543,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
      <Box
          display="flex"
          p="0px 0px 100px 0px"
          justifyContent="center"
          flexDirection="column"
          bg="#f7f8fc"
      >
        <Box display="flex" justifyContent="center" mb={{ base: "55px", md: "80px" }}>
          <Heading
              color="#090632"
              fontSize={{ base: "32px", md: "48px" }}
              lineHeight="1.2"
          >
            Categories
          </Heading>
        </Box>

        <Box w="70%" margin="auto">
          <Slider {...settings}>
            {categoryData.map((category, index) => (
                <Box
                    key={index}
                    display="grid"
                    justifyContent="center"
                    mb={gapBetweenBoxes}
                    _hover={{
                      transform: "scale(1.05)",
                      transition: "all 0.3s ease-in-out",
                    }}
                    p="10px"
                    borderRadius="10px"
                    cursor="pointer"
                >
                  <Box display="grid" height="300px">
                    <CategoriesPageCardItem {...category} />
                  </Box>
                </Box>
            ))}
          </Slider>
        </Box>
      </Box>
  );
};

export default Categories;
